import React, { FC, useEffect } from 'react';
import { CancelIcon } from '../../../assets/icons';

type Props = {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  title: string;
  icon?: JSX.Element;
};

const Modal: FC<Props> = ({ children, open, onClose, title, icon }) => {
  // USEFFECT FOR STATIC OVERLAY
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [open]);

  return (
    <React.Fragment>
      {open ? (
        <div className='flex backdrop-blur-xs bg-[rgba(0,0,0,0.5)]  cursor-default justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
          <div className='relative my-6 bg-white w-full max-w-xl p-4 shadow-2xl rounded-md'>
            <div className='flex justify-between items-center'>
              <div className='flex items-center gap-2 '>
                {icon ? icon : null}
                <p className='text-[18px] font-[500]'>{title}</p>
              </div>
              <button onClick={onClose}>
                <CancelIcon />
              </button>
            </div>
            {/* Modal Content */}
            {children}
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Modal;
